function confirmRemoveProperty(propertyName, propertyId) {

    swal({
        title: "Are you sure?",
        text: propertyName + " will be removed from the property list",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes, remove.",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnDeletePropertyConfirmed', propertyId);


        });
}



function FileChosenPropertyImage(e) {

    try {
        var fileName = $('#inputGroupFileProperty').prop('files')[0].name;
        document.getElementById('chosenFilePropertyLabel').innerHTML = fileName;
    } catch (e) {

    }


}



function UploadPropertyImageFile(arg, propertyid) {
    var url = 'https://visitform.com/app/api/Image/imageupload/property/';
    if (release == false) {
        url = 'https://localhost:5001/api/Image/imageupload/property/';
    }
    // $('#upload').on('click', function () {
    var file_data = $('#inputGroupFileProperty').prop('files')[0];
    console.log(file_data);
    var form_data = new FormData();
    form_data.append('file', file_data);
    $.ajax({
        url: url + propertyid,
        dataType: 'text',
        cache: false,
        contentType: false,
        processData: false,
        data: form_data,
        type: 'post',
        beforeSend: function (xhr) {   //Include the bearer token in header
            xhr.setRequestHeader("Authorization", 'Bearer ' + arg);
        },
        success: function (response) {
            //  $('#msg').html(response); 
        },
        error: function (response) {
            //  $('#msg').html(response); 
        }
    });
    //  });
}